const Home1 = () => import('@/views/Home1')

export default [
  {
    path: '/home1',
    component: Home1,
    meta: { requireAuth: true }
  }
]
